'use client'

import Link from 'next/link'
import { useFavorites } from '@/context/FavoritesContext'
import { MovieCard } from '@/components/ui/MovieCard'
import { CardSkeleton } from '@/components/ui/Skeletons'
import type { ContentItem, FavoriteItem } from '@/lib/types'

function toContentItem(f: FavoriteItem): ContentItem {
  return {
    id: f.id,
    type: f.type,
    title: f.title,
    poster: f.poster,
    backdrop: null,
    logo: null,
    year: f.year,
    rating: f.rating,
    genres: f.genres || [],
    overview: null,
    runtime: null,
    runtimeMinutes: null,
  }
}

export default function FavorilerPage() {
  const { favorites, ready } = useFavorites()

  return (
    <div className="container-page py-10">
      <div className="mb-8">
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
          ❤️ Favorilerim
        </h1>
        <p className="mt-2 text-neutral-400">
          Kaydettiğin film ve diziler burada. Sayfayı yenilesen de kaybolmazlar.
        </p>
      </div>

      {!ready ? (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <CardSkeleton key={i} />
          ))}
        </div>
      ) : favorites.length === 0 ? (
        <div className="mx-auto max-w-md rounded-2xl border border-white/10 bg-ink-800/60 p-10 text-center">
          <div className="mb-3 text-4xl">🤍</div>
          <h2 className="font-display text-lg font-bold text-white">Henüz favorin yok</h2>
          <p className="mt-2 text-sm text-neutral-400">
            Beğendiğin film ve dizileri favorilerine ekleyerek buradan kolayca ulaşabilirsin.
          </p>
          <Link href="/kesfet" className="btn-primary mt-6">Keşfetmeye Başla</Link>
        </div>
      ) : (
        <>
          <p className="mb-4 text-sm text-neutral-500">{favorites.length} içerik</p>
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
            {favorites.map((f) => (
              <MovieCard key={`${f.type}-${f.id}`} item={toContentItem(f)} />
            ))}
          </div>
        </>
      )}
    </div>
  )
}
